import { render, staticRenderFns } from "./SwapLoadingTransactionStep.vue?vue&type=template&id=2aa1fdea&scoped=true"
import script from "./SwapLoadingTransactionStep.vue?vue&type=script&lang=ts"
export * from "./SwapLoadingTransactionStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa1fdea",
  null
  
)

export default component.exports